<template>
  <div class="webNotice" v-if="showNotice">
    <div class="notice-header">
      <div class="notice-icon">
        <i class="el-icon-bell"></i>
      </div>
      <div class="notice-title">网站公告</div>
      <div class="close-btn" @click="closeBox">
        <i class="el-icon-close"></i>
      </div>
    </div>
    <div class="notice-content" v-html="webNotice.content"></div>
  </div>
</template>

<script>

import {getWebNotice} from "../../api/messagePush";
import {getCookie, setCookie} from "../../utils/cookieUtils";

export default {
  name: "WebNotice",
  data() {
    return {
      webNotice: {},
      showNotice: false
    };
  },
  components: {},
  created() {
    this.getWebNoticeInfo()
  },
  mounted() {

  },
  watch: {
  },
  methods: {
    getWebNoticeInfo() {
      getWebNotice().then(res => {
        if (res.code == this.$ECode.SUCCESS) {
          this.webNotice = res.data
          let webNoticeUid = getCookie('webNotice')
          // 判断是否点击过公告
          if (webNoticeUid == this.webNotice.uid) {
            this.showNotice = false
          } else {
            this.showNotice = true
          }
        }
      })
    },
    closeBox: function () {
      let webNotice = this.webNotice
      this.showNotice = false
      if (!webNotice) {
        return
      }
      setCookie("webNotice", webNotice.uid, 100)
    },
  }
};
</script>


<style scoped>
.webNotice {
  position: fixed;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  max-width: 600px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  z-index: 9999;
  overflow: hidden;
  animation: slideDown 0.5s ease-out;
}

.notice-header {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.notice-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}

.notice-icon i {
  font-size: 16px;
  color: #fff;
  animation: bell 2s infinite;
}

.notice-title {
  flex: 1;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.close-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

.close-btn i {
  font-size: 14px;
  color: #fff;
}

.notice-content {
  padding: 20px;
  color: #fff;
  line-height: 1.6;
  font-size: 14px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.notice-content ::v-deep a {
  color: #fff;
  text-decoration: underline;
  opacity: 0.9;
}

.notice-content ::v-deep a:hover {
  opacity: 1;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

@keyframes bell {
  0%, 50%, 100% {
    transform: rotate(0deg);
  }
  10%, 30% {
    transform: rotate(-10deg);
  }
  20%, 40% {
    transform: rotate(10deg);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .webNotice {
    top: 60px;
    width: 95%;
    margin: 0 10px;
  }
  
  .notice-header {
    padding: 12px 16px;
  }
  
  .notice-content {
    padding: 16px;
    font-size: 13px;
  }
}

/* 暗色主题适配 */
@media (prefers-color-scheme: dark) {
  .webNotice {
    background: linear-gradient(135deg, #2d3748 0%, #4a5568 100%);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/WebNotice/index.vue